// istanbul ignore file
// TODO APPS-11349-add-coverage-remove-istanbul-ignore
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { TextField } from '@clds/text-field';
import { Icon } from '@cld/icon';

export const Root = styled.div`
  display: flex;
  align-items: center;
  ${typography.xs.regular};
  gap: ${globalTheme.spacing.lg};

  > ${Icon} {
    colour: ${globalTheme.palette.contrastHigh};
  }
`;

export const PaginationSwitcher = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const PageInput = styled(TextField)`
  min-width: auto;
  margin: 0 ${globalTheme.spacing.xs};
  width: 30px;

  input {
    text-align: center;
    
    &[type=number]::-webkit-inner-spin-button, 
    &[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none; 
    }
    
    &[type=number] {
      -moz-appearance: textfield;
    }
  }
}
`;
